import { TComment } from "../comment/comment.types";
// The count for new comments and replies is skipped because they show up right at the top of the comment or reply list.
export const resolveCommentsLength = (comments: TComment[]) => comments.filter(comment => !comment?.ignoreCounting).length;
